// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline_wrapper__SezS4 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: white;
  overflow: auto;
  height: calc(100vh - 230px); }

.timeline_container__Je6fi {
  background-color: white;
  padding: 12px 20px;
  border-bottom: 1px solid #e0e0e0; }
  .timeline_container__Je6fi > h1 {
    font-weight: 600;
    font-size: 24px;
    line-height: 150%; }
  .timeline_container__Je6fi .timeline_camera__MbPGQ {
    background-color: white;
    padding: 5px;
    border-radius: 4px; }
  .timeline_container__Je6fi .timeline_algorithm__mdOqK {
    display: flex;
    flex-direction: column;
    gap: 20px; }

.timeline_timeline__0bUbc {
  display: flex;
  align-items: center;
  height: 30px;
  width: 100%;
  margin: 7px 0; }
  .timeline_timeline__description__PhJVS {
    width: 100%; }
  .timeline_timeline__text__ujayb {
    width: 120px;
    font-weight: 600;
    font-size: 13px;
    text-align: center; }
  .timeline_timeline__line__azVPU {
    padding-left: 120px;
    margin: 5px 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: #9e9e9e;
    font-size: 12px; }
  .timeline_timeline__timezone__Yftns {
    text-align: center;
    width: 100%;
    cursor: pointer;
    color: #9e9e9e;
    transition: all 0.4s; }
    .timeline_timeline__timezone__Yftns:hover {
      color: #fe6100; }
  .timeline_timeline__zoomout__7dsmL span {
    font-size: 12px; }

.timeline_line__vnsbO {
  height: 100%;
  width: calc(100% - 120px);
  background-color: #e0e0e0;
  display: flex;
  border-radius: 6px;
  overflow: hidden; }
  .timeline_line__vnsbO .timeline_red__CojPQ {
    height: 100%;
    background-color: #e00606;
    position: relative;
    box-sizing: border-box;
    cursor: pointer; }
  .timeline_line__vnsbO .timeline_green__r6F58 {
    height: 100%;
    background-color: #87bc45;
    box-sizing: border-box;
    cursor: pointer; }
  .timeline_line__vnsbO .timeline_yellow__MfppB {
    width: 5px;
    background-color: yellow; }
  .timeline_line__vnsbO .timeline_grey__9YQiU {
    height: 100%;
    background-color: #838383; }
  .timeline_line__vnsbO > span {
    transition: all 0.3s; }
    .timeline_line__vnsbO > span:hover {
      background-color: yellow; }

.timeline_fullscreen__vr5Cb {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9000;
  width: 100vw;
  height: 100vh;
  max-height: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  overflow: auto;
  transition: all 0.4s; }
  .timeline_fullscreen__container__9-Sol {
    width: 800px;
    max-height: calc(80vh - 1px);
    background: #ffffff;
    border-radius: 5px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    position: relative;
    z-index: 9001; }
  .timeline_fullscreen__image__3gM2O {
    position: relative;
    max-width: 800px;
    max-height: calc(80vh - 170px); }
  .timeline_fullscreen__footer__acwMf {
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    background-color: #ffffff; }
    .timeline_fullscreen__footer_up__Yn1Ae {
      display: flex;
      justify-content: space-between; }
    .timeline_fullscreen__footer_time__qmLhB {
      font-weight: 600;
      font-size: 14px;
      line-height: 150%; }
    .timeline_fullscreen__footer_text__wFIqZ {
      font-weight: 400;
      font-size: 12px;
      line-height: 150%; }
      .timeline_fullscreen__footer_text__wFIqZ span {
        color: #666666; }
      .timeline_fullscreen__footer_text__wFIqZ .timeline_link__AcL4p {
        font-weight: 400;
        font-size: 12px;
        line-height: 150%;
        color: #fe6100;
        cursor: pointer;
        transition: all 0.4s; }
        .timeline_fullscreen__footer_text__wFIqZ .timeline_link__AcL4p:hover {
          color: #e55700; }
  .timeline_fullscreen__close__8wgXS {
    position: absolute;
    top: 0px;
    right: -45px;
    padding: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(33, 33, 33, 0.87);
    border-radius: 50%;
    opacity: 0.7;
    transition: all 0.4s ease-in-out;
    cursor: pointer; }
    .timeline_fullscreen__close__8wgXS:hover {
      opacity: 1; }
  .timeline_fullscreen__vr5Cb .timeline_arrowLeft__dccco {
    width: 30px;
    height: 30px;
    position: absolute;
    top: calc(50% - 15px);
    left: -40px;
    transform: rotate(180deg);
    opacity: 0.8;
    transition: all 0.3s;
    cursor: pointer; }
    .timeline_fullscreen__vr5Cb .timeline_arrowLeft__dccco:hover {
      opacity: 1; }
  .timeline_fullscreen__vr5Cb .timeline_arrowRight__MTLV0 {
    width: 30px;
    height: 30px;
    position: absolute;
    top: calc(50% - 15px);
    right: -40px;
    opacity: 0.8;
    transition: all 0.3s;
    cursor: pointer; }
    .timeline_fullscreen__vr5Cb .timeline_arrowRight__MTLV0:hover {
      opacity: 1; }

.timeline_hover__N0EzL {
  position: fixed;
  background: #ffffff;
  box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 10px 14px;
  z-index: 999; }
  .timeline_hover__N0EzL h6 {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: #666666; }
  .timeline_hover__time__cUDI4 {
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 10px; }
    .timeline_hover__time__cUDI4 span {
      color: #9e9e9e; }

.timeline_lupa__ztpIO {
  width: 20px;
  height: 20px;
  color: #666666; }

.timeline_lupaOrange__nxFBs {
  color: #fe6100; }

.timeline_zoneName__vSx1L {
  width: 100%;
  border-top: 1px solid #e0e0e0;
  padding: 10px 0; }

.timeline_fullImage__BqjMo {
  width: 100vw;
  height: 100vh;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  background-color: #00000070;
  backdrop-filter: blur(5px);
  z-index: 9000;
  cursor: pointer; }
  .timeline_fullImage__container__Gzf2e {
    position: relative;
    width: 85vw;
    height: max-content;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center; }
  .timeline_fullImage__scale__XDVzT {
    position: absolute;
    bottom: 10px;
    right: 10px; }

.timeline_scale__GgfGS {
  position: absolute;
  bottom: 20px;
  right: 10px; }
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/components/timeline/timeline.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,2BAA2B,EAAA;;AAE7B;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC,EAAA;EAHlC;IAMI,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EARrB;IAWI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB,EAAA;EAbtB;IAgBI,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAA;;AAGb;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa,EAAA;EACb;IACE,WAAW,EAAA;EAGb;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB,EAAA;EAEpB;IACE,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,eAAe,EAAA;EAGjB;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,cAAc;IACd,oBAAoB,EAAA;IALrB;MAQG,cAAsB,EAAA;EAGzB;IAEG,eAAe,EAAA;;AAKrB;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB,EAAA;EANlB;IAQI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe,EAAA;EAZnB;IAeI,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,eAAe,EAAA;EAlBnB;IAqBI,UAAU;IACV,wBAAwB,EAAA;EAtB5B;IAyBI,YAAY;IACZ,yBAAyB,EAAA;EA1B7B;IA6BI,oBAAoB,EAAA;IA7BxB;MA+BM,wBAAwB,EAAA;;AAI9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,oBAAoB,EAAA;EAEpB;IACE,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;IAClB,iDAAiD;IACjD,kBAAkB;IAClB,aAAa,EAAA;EAEf;IACE,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B,EAAA;EAEhC;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,yBAAyB,EAAA;IACzB;MACE,aAAa;MACb,8BAA8B,EAAA;IAEhC;MACE,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;IAGnB;MACE,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;MAHlB;QAKG,cAAc,EAAA;MALjB;QAQG,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,eAAe;QACf,oBAAoB,EAAA;QAbvB;UAeK,cAAc,EAAA;EAKtB;IACE,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;IAChC,eAAe,EAAA;IAZhB;MAcG,UAAU,EAAA;EA/EhB;IAmFI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,eAAe,EAAA;IA3FnB;MA6FM,UAAU,EAAA;EA7FhB;IAiGI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,eAAe,EAAA;IAxGnB;MA0GM,UAAU,EAAA;;AAIhB;EACE,eAAe;EACf,mBAAmB;EACnB,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY,EAAA;EARd;IAUI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAA;EAEhB;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB,EAAA;IAHpB;MAKG,cAAc,EAAA;;AAMpB;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,WAAW;EACX,6BAA6B;EAC7B,eAAe,EAAA;;AAGjB;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,eAAe,EAAA;EACf;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;EAEzB;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW,EAAA;;AAGf;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW,EAAA","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  background-color: white;\n  overflow: auto;\n  height: calc(100vh - 230px);\n}\n.container {\n  background-color: white;\n  padding: 12px 20px;\n  border-bottom: 1px solid #e0e0e0;\n  \n  > h1 {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 150%;\n  }\n  .camera {\n    background-color: white;\n    padding: 5px;\n    border-radius: 4px;\n  }\n  .algorithm {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n}\n.timeline {\n  display: flex;\n  align-items: center;\n  height: 30px;\n  width: 100%;\n  margin: 7px 0;\n  &__description {\n    width: 100%;\n  }\n\n  &__text {\n    width: 120px;\n    font-weight: 600;\n    font-size: 13px;\n    text-align: center;\n  }\n  &__line {\n    padding-left: 120px;\n    margin: 5px 0;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    color: #9e9e9e;\n    font-size: 12px;\n  }\n\n  &__timezone {\n    text-align: center;\n    width: 100%;\n    cursor: pointer;\n    color: #9e9e9e;\n    transition: all 0.4s;\n    \n    &:hover {\n      color: rgb(254, 97, 0);\n    }\n  }\n  &__zoomout {\n    span{\n      font-size: 12px;\n    }\n    \n  }\n}\n.line {\n  height: 100%;\n  width: calc(100% - 120px);\n  background-color: #e0e0e0;\n  display: flex;\n  border-radius: 6px;\n  overflow: hidden;\n  .red {\n    height: 100%;\n    background-color: #e00606;\n    position: relative;\n    box-sizing: border-box;\n    cursor: pointer;\n  }\n  .green {\n    height: 100%;\n    background-color: #87bc45;\n    box-sizing: border-box;\n    cursor: pointer;\n  }\n  .yellow {\n    width: 5px;\n    background-color: yellow;\n  }\n  .grey {\n    height: 100%;\n    background-color: #838383;\n  }\n  > span {\n    transition: all 0.3s;\n    &:hover {\n      background-color: yellow;\n    }\n  }\n}\n.fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9000;\n  width: 100vw;\n  height: 100vh;\n  max-height: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.5);\n  overflow: auto;\n  transition: all 0.4s;\n\n  &__container {\n    width: 800px;\n    max-height: calc(80vh - 1px);\n    background: #ffffff;\n    border-radius: 5px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    position: relative;\n    z-index: 9001;\n  }\n  &__image {\n    position: relative;\n    max-width: 800px;\n    max-height: calc(80vh - 170px);\n  }\n  &__footer {\n    padding: 20px 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    background-color: #ffffff;\n    &_up {\n      display: flex;\n      justify-content: space-between;\n    }\n    &_time {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 150%;\n    }\n\n    &_text {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 150%;\n      span {\n        color: #666666;\n      }\n      .link {\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 150%;\n        color: #fe6100;\n        cursor: pointer;\n        transition: all 0.4s;\n        &:hover {\n          color: #e55700;\n        }\n      }\n    }\n  }\n  &__close {\n    position: absolute;\n    top: 0px;\n    right: -45px;\n    padding: 11px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(33, 33, 33, 0.87);\n    border-radius: 50%;\n    opacity: 0.7;\n    transition: all 0.4s ease-in-out;\n    cursor: pointer;\n    &:hover {\n      opacity: 1;\n    }\n  }\n  .arrowLeft {\n    width: 30px;\n    height: 30px;\n    position: absolute;\n    top: calc(50% - 15px);\n    left: -40px;\n    transform: rotate(180deg);\n    opacity: 0.8;\n    transition: all 0.3s;\n    cursor: pointer;\n    &:hover {\n      opacity: 1;\n    }\n  }\n  .arrowRight {\n    width: 30px;\n    height: 30px;\n    position: absolute;\n    top: calc(50% - 15px);\n    right: -40px;\n    opacity: 0.8;\n    transition: all 0.3s;\n    cursor: pointer;\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n.hover {\n  position: fixed;\n  background: #ffffff;\n  box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);\n  display: flex;\n  flex-direction: column;\n  border-radius: 4px;\n  padding: 10px 14px;\n  z-index: 999;\n  h6 {\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 150%;\n    color: #666666;\n  }\n  &__time {\n    font-weight: 400;\n    font-size: 16px;\n    margin-bottom: 10px;\n    span {\n      color: #9e9e9e;\n      \n    }\n  }\n}\n\n.lupa {\n  width: 20px;\n  height: 20px;\n  color: #666666;\n}\n.lupaOrange {\n  color: #fe6100;\n}\n.zoneName {\n  width: 100%;\n  border-top: 1px solid #e0e0e0;\n  padding: 10px 0;\n}\n\n.fullImage {\n  width: 100vw;\n  height: 100vh;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 0;\n  left: 0;\n  background-color: #00000070;\n  backdrop-filter: blur(5px);\n  z-index: 9000;\n  cursor: pointer;\n  &__container {\n    position: relative;\n    width: 85vw;\n    height: max-content;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  &__scale {\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n  }\n}\n.scale {\n  position: absolute;\n  bottom: 20px;\n  right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `timeline_wrapper__SezS4`,
	"container": `timeline_container__Je6fi`,
	"camera": `timeline_camera__MbPGQ`,
	"algorithm": `timeline_algorithm__mdOqK`,
	"timeline": `timeline_timeline__0bUbc`,
	"timeline__description": `timeline_timeline__description__PhJVS`,
	"timeline__text": `timeline_timeline__text__ujayb`,
	"timeline__line": `timeline_timeline__line__azVPU`,
	"timeline__timezone": `timeline_timeline__timezone__Yftns`,
	"timeline__zoomout": `timeline_timeline__zoomout__7dsmL`,
	"line": `timeline_line__vnsbO`,
	"red": `timeline_red__CojPQ`,
	"green": `timeline_green__r6F58`,
	"yellow": `timeline_yellow__MfppB`,
	"grey": `timeline_grey__9YQiU`,
	"fullscreen": `timeline_fullscreen__vr5Cb`,
	"fullscreen__container": `timeline_fullscreen__container__9-Sol`,
	"fullscreen__image": `timeline_fullscreen__image__3gM2O`,
	"fullscreen__footer": `timeline_fullscreen__footer__acwMf`,
	"fullscreen__footer_up": `timeline_fullscreen__footer_up__Yn1Ae`,
	"fullscreen__footer_time": `timeline_fullscreen__footer_time__qmLhB`,
	"fullscreen__footer_text": `timeline_fullscreen__footer_text__wFIqZ`,
	"link": `timeline_link__AcL4p`,
	"fullscreen__close": `timeline_fullscreen__close__8wgXS`,
	"arrowLeft": `timeline_arrowLeft__dccco`,
	"arrowRight": `timeline_arrowRight__MTLV0`,
	"hover": `timeline_hover__N0EzL`,
	"hover__time": `timeline_hover__time__cUDI4`,
	"lupa": `timeline_lupa__ztpIO`,
	"lupaOrange": `timeline_lupaOrange__nxFBs`,
	"zoneName": `timeline_zoneName__vSx1L`,
	"fullImage": `timeline_fullImage__BqjMo`,
	"fullImage__container": `timeline_fullImage__container__Gzf2e`,
	"fullImage__scale": `timeline_fullImage__scale__XDVzT`,
	"scale": `timeline_scale__GgfGS`
};
export default ___CSS_LOADER_EXPORT___;
